import { createFileRoute } from '@tanstack/react-router';
import { PortalDocuments } from '@/features/portal/PortalDocuments';

export const Route = createFileRoute('/_portal/portal/documenti')({ component: PortalDocuments });
